export default __webpack_public_path__ + "static/work-hirez-34d4ab48a3e2b72a7e1a2aa0ad83c053.jpg";